import styled from 'styled-components';

export const IconContainer = styled.div`
  width: 19.5px;
  height: 19.5px;
  border-radius: 4px;
  background-color: ${props => props.color || '#CACACA'}20;
  border: 1px solid ${props => props.color || '#CACACA'}40;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
  
  &:hover {
    transform: scale(1.1);
    box-shadow: 0 2px 6px ${props => props.color || '#CACACA'}66;
  }
  
  svg {
    width: 12px;
    height: 12px;
    color: ${props => props.color || '#7b7b7b'};
  }
`;

